// Catalog loading-state coordinator.
//
// Multiple async tasks (REST /listings, REST /filter-facets) can be in
// flight at the same time. A boolean flag would flicker as each one ends.
// We refcount instead - every begin() increments, every end() decrements,
// and the `data-catalog-loading` attribute is only cleared when the count
// hits zero. CSS reacts to that attribute (see components/loading.css).
//
// A short minimum visible duration prevents the bar from blinking on
// near-instant fetches.

const MIN_VISIBLE_MS = 220;
let count = 0;
let shownAt = 0;
let hideTimer = 0;

function apply() {
  if (count > 0) {
    document.body.setAttribute('data-catalog-loading', '1');
    if (!shownAt) shownAt = performance.now();
    if (hideTimer) { clearTimeout(hideTimer); hideTimer = 0; }
    return;
  }
  // Don't hide before MIN_VISIBLE_MS has elapsed since first show - keeps
  // the bar perceptible on fast networks.
  const elapsed = shownAt ? performance.now() - shownAt : MIN_VISIBLE_MS;
  const wait = Math.max(0, MIN_VISIBLE_MS - elapsed);
  hideTimer = setTimeout(() => {
    document.body.removeAttribute('data-catalog-loading');
    shownAt = 0;
    hideTimer = 0;
  }, wait);
}

export function beginCatalogLoading() {
  count++;
  apply();
}

export function endCatalogLoading() {
  count = Math.max(0, count - 1);
  apply();
}

// Convenience wrapper for async functions - guarantees the counter is
// decremented even on throw.
export async function withCatalogLoading(fn) {
  beginCatalogLoading();
  try { return await fn(); }
  finally { endCatalogLoading(); }
}
